var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticStyle: { display: "flex", "flex-direction": "column", gap: "10px" },
    },
    [
      false
        ? [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  gap: "10px",
                  "align-items": "center",
                },
              },
              [
                _c("div", [_vm._v("Select BioIndex:")]),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedBI,
                        expression: "selectedBI",
                      },
                    ],
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedBI = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        function ($event) {
                          return _vm.selectBioIndex($event.target.value)
                        },
                      ],
                    },
                  },
                  _vm._l(_vm.singleCellBI, function (bi) {
                    return _c("option", { domProps: { value: bi.bioIndex } }, [
                      _vm._v(" " + _vm._s(bi.name) + " "),
                    ])
                  }),
                  0
                ),
                _c("b-pagination", {
                  staticClass: "pagination justify-content-center",
                  attrs: {
                    "total-rows": _vm.totalDatasets,
                    "per-page": _vm.datasetsPerPage,
                  },
                  model: {
                    value: _vm.currentDatasetsPage,
                    callback: function ($$v) {
                      _vm.currentDatasetsPage = $$v
                    },
                    expression: "currentDatasetsPage",
                  },
                }),
              ],
              1
            ),
            _vm.filteredMetadata
              ? _c("b-table", {
                  attrs: {
                    items: _vm.filteredMetadata,
                    fields: _vm.tableColumns,
                    striped: "",
                    hover: "",
                    responsive: "sm",
                    "head-variant": "light",
                    "per-page": _vm.datasetsPerPage,
                    "current-page": _vm.currentDatasetsPage,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "cell(datasetId)",
                        fn: function (data) {
                          return [
                            data.item.datasetId !== _vm.datasetId
                              ? _c(
                                  "button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectDataset(
                                          data.item.datasetId
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Select")]
                                )
                              : _c("div", [_vm._v("Selected")]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3917555800
                  ),
                })
              : _vm._e(),
            _vm.datasetId
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      gap: "10px",
                      "align-items": "center",
                    },
                  },
                  [
                    _c("div", [_vm._v("Select Layout:")]),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.layout,
                            expression: "layout",
                          },
                        ],
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.layout = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function ($event) {
                              return _vm.selectLayout($event.target.value)
                            },
                          ],
                        },
                      },
                      _vm._l(_vm.layoutOptions, function (layout) {
                        return _c(
                          "option",
                          { domProps: { value: layout.value } },
                          [_vm._v(" " + _vm._s(layout.name) + " ")]
                        )
                      }),
                      0
                    ),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
      false
        ? [
            _c("div", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v("Select Tissue"),
            ]),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.datasetId,
                    expression: "datasetId",
                  },
                ],
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.datasetId = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    function ($event) {
                      return _vm.selectDataset(_vm.data.item.datasetId)
                    },
                  ],
                },
              },
              [
                _c("option", { domProps: { value: null } }, [
                  _vm._v("--Select--"),
                ]),
                _vm._l(_vm.singleCellMetadata, function (item) {
                  return _c("option", { domProps: { value: item.datasetId } }, [
                    _vm._v(
                      _vm._s(item.tissue) +
                        " (" +
                        _vm._s(item.totalCells.toLocaleString()) +
                        " cells)"
                    ),
                  ])
                }),
              ],
              2
            ),
          ]
        : _vm._e(),
      _vm.showDatasetSelect
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                gap: "10px",
              },
            },
            [
              _vm._m(0),
              _vm.singleCellMetadata
                ? _c("b-table", {
                    attrs: {
                      items: _vm.singleCellMetadata,
                      fields: _vm.tableColumns,
                      small: "",
                      striped: "",
                      hover: "",
                      responsive: "sm",
                      "head-variant": "light",
                      "sticky-header": "300px",
                      "per-page": _vm.datasetsPerPage,
                      "current-page": _vm.currentDatasetsPage,
                      "tbody-tr-class": _vm.datasetsRowClass,
                    },
                    on: {
                      "row-clicked": (item) =>
                        _vm.selectDataset(item.datasetId),
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell(datasetId)",
                          fn: function (data) {
                            return [
                              data.item.datasetId !== _vm.datasetId
                                ? _c(
                                    "button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectDataset(
                                            data.item.datasetId
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Select")]
                                  )
                                : _c("div", [_vm._v("Selected")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3917555800
                    ),
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      !_vm.datasetId
        ? _c("div", { staticStyle: { color: "red", margin: "0 auto" } }, [
            _vm._v(" Please Select a Dataset "),
          ])
        : _vm._e(),
      _vm.datasetId && !_vm.dataLoaded
        ? _c("div", { staticStyle: { margin: "0 auto" } }, [
            _vm._v(" Loading " + _vm._s(_vm.preloadItem) + "... "),
          ])
        : _vm._e(),
      _vm.dataLoaded
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                gap: "20px",
                width: "100%",
                "max-width": "100%",
                "overflow-x": "auto",
              },
            },
            [
              _vm.layout === 0
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        gap: "20px",
                        background: "#f8f8f8",
                        padding: "20px",
                        width: "100%",
                        "min-width": "840px",
                      },
                    },
                    [
                      _vm.metadata
                        ? _c("research-single-cell-info", {
                            attrs: { data: _vm.metadata },
                          })
                        : _vm._e(),
                      _vm.dataReady
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                                gap: "20px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { display: "flex", gap: "20px" },
                                },
                                [
                                  _vm.coordinates
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            gap: "20px",
                                            flex: "1",
                                            padding: "20px",
                                            background: "white",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                                width: "min-content",
                                                flex: "1",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content":
                                                      "space-between",
                                                    "align-items": "baseline",
                                                    margin: "0 0 5px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "strong",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "16px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Cell Type Clustering"
                                                      ),
                                                    ]
                                                  ),
                                                  _c("div", [
                                                    _vm._v(
                                                      "UMAP " +
                                                        _vm._s(
                                                          _vm.totalCells.toLocaleString()
                                                        ) +
                                                        " cells"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c("research-umap-plot-gl", {
                                                attrs: {
                                                  group: _vm.datasetId,
                                                  points: _vm.coordinates,
                                                  labels: _vm.fields,
                                                  colors: _vm.labelColors,
                                                  cellTypeField:
                                                    _vm.cellTypeField,
                                                  colorByField:
                                                    _vm.cellCompositionVars
                                                      .colorByField,
                                                  hoverFields: [],
                                                  highlightLabel:
                                                    _vm.cellCompositionVars
                                                      .highlightLabel,
                                                  highlightLabels:
                                                    _vm.cellCompositionVars
                                                      .highlightLabels,
                                                  width: 400,
                                                  height: 400,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm.colorByFields
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "flex-direction": "column",
                                                    "align-self": "flex-start",
                                                    width: "200px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "strong",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "16px",
                                                        margin: "0 0 5px",
                                                      },
                                                    },
                                                    [_vm._v("Color By")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "flex-direction":
                                                          "column",
                                                        height: "400px",
                                                        gap: "5px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .cellCompositionVars
                                                                  .colorByField,
                                                              expression:
                                                                "cellCompositionVars.colorByField",
                                                            },
                                                          ],
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          on: {
                                                            change: [
                                                              function (
                                                                $event
                                                              ) {
                                                                var $$selectedVal =
                                                                  Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function (
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                _vm.$set(
                                                                  _vm.cellCompositionVars,
                                                                  "colorByField",
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                )
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.selectColorBy(
                                                                  $event.target
                                                                    .value
                                                                )
                                                              },
                                                            ],
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "--Select--"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._l(
                                                            _vm.colorByFields
                                                              .show,
                                                            function (
                                                              value,
                                                              key
                                                            ) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  domProps: {
                                                                    value: key,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.displayLabel(
                                                                          key
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                            "flex-grow": "1",
                                                            "overflow-x":
                                                              "hidden",
                                                            "overflow-y":
                                                              "auto",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "research-single-cell-selector",
                                                            {
                                                              attrs: {
                                                                data: _vm
                                                                  .fields[
                                                                  "metadata_labels"
                                                                ],
                                                                displayData:
                                                                  _vm.displayFields,
                                                                selectedField:
                                                                  _vm
                                                                    .cellCompositionVars
                                                                    .colorByField,
                                                                layout: "list",
                                                                colors:
                                                                  _vm.labelColors,
                                                              },
                                                              on: {
                                                                "on-update":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleSelectorUpdate(
                                                                      $event
                                                                    )
                                                                  },
                                                                "on-hover":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleSelectorHover(
                                                                      $event
                                                                    )
                                                                  },
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.coordinates
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            gap: "20px",
                                            flex: "1",
                                            padding: "20px",
                                            background: "white",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                                width: "min-content",
                                                flex: "1",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content":
                                                      "space-between",
                                                    "align-items": "baseline",
                                                    margin: "0 0 5px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "strong",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "16px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.geneExpressionVars
                                                            .selectedGene
                                                            ? `${_vm.geneExpressionVars.selectedGene}`
                                                            : "Gene"
                                                        ) + " Expression"
                                                      ),
                                                    ]
                                                  ),
                                                  _c("div", [
                                                    _vm._v(
                                                      "UMAP " +
                                                        _vm._s(
                                                          _vm.totalCells.toLocaleString()
                                                        ) +
                                                        " cells"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "relative",
                                                    width: "100%",
                                                  },
                                                },
                                                [
                                                  _c("research-umap-plot-gl", {
                                                    attrs: {
                                                      group: _vm.datasetId,
                                                      points: _vm.coordinates,
                                                      labels: _vm.fields,
                                                      colors: _vm.labelColors,
                                                      expression:
                                                        _vm.expressionData[
                                                          _vm.geneExpressionVars
                                                            .selectedGene
                                                        ],
                                                      cellTypeField:
                                                        _vm.cellTypeField,
                                                      hoverFields: [],
                                                      highlightLabel:
                                                        _vm.cellCompositionVars
                                                          .highlightLabel,
                                                      highlightLabels:
                                                        _vm.cellCompositionVars
                                                          .highlightLabels,
                                                      width: 400,
                                                      height: 400,
                                                    },
                                                  }),
                                                  _vm.expressionData[
                                                    _vm.geneExpressionVars
                                                      .selectedGene
                                                  ]
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass: "legend",
                                                          staticStyle: {
                                                            display: "flex",
                                                            "flex-direction":
                                                              "column",
                                                            position:
                                                              "absolute",
                                                            top: "4px",
                                                            left: "5px",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Expression"
                                                              ),
                                                            ]
                                                          ),
                                                          _c("div", {
                                                            staticClass:
                                                              "gradient",
                                                            style: `background: linear-gradient(to right, ${_vm.colorScalePlasmaColorsArray}); height:5px;`,
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "marks",
                                                              staticStyle: {
                                                                display: "flex",
                                                              },
                                                            },
                                                            [
                                                              _c("div", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.minExpressionValue(
                                                                      _vm
                                                                        .geneExpressionVars
                                                                        .selectedGene
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.maxExpressionValue(
                                                                      _vm
                                                                        .geneExpressionVars
                                                                        .selectedGene
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                                "align-self": "flex-start",
                                                width: "200px",
                                              },
                                            },
                                            [
                                              _c(
                                                "strong",
                                                {
                                                  staticStyle: {
                                                    "font-size": "16px",
                                                    margin: "0 0 5px",
                                                  },
                                                },
                                                [_vm._v("Gene Search")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "flex-direction": "column",
                                                    height: "400px",
                                                    gap: "5px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        gap: "5px",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.geneToSearch,
                                                            expression:
                                                              "geneToSearch",
                                                          },
                                                        ],
                                                        staticStyle: {
                                                          width: "100%",
                                                          position: "relative",
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          placeholder:
                                                            "Gene name",
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.geneToSearch,
                                                        },
                                                        on: {
                                                          keyup: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              !$event.type.indexOf(
                                                                "key"
                                                              ) &&
                                                              _vm._k(
                                                                $event.keyCode,
                                                                "enter",
                                                                13,
                                                                $event.key,
                                                                "Enter"
                                                              )
                                                            )
                                                              return null
                                                            return _vm.searchGene(
                                                              _vm.geneToSearch
                                                            )
                                                          },
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.geneToSearch =
                                                              $event.target.value
                                                          },
                                                        },
                                                      }),
                                                      _c(
                                                        "button",
                                                        {
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.searchGene(
                                                                _vm.geneToSearch
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "svg",
                                                            {
                                                              staticStyle: {
                                                                width: "20px",
                                                              },
                                                              style: `display:${
                                                                !_vm.geneLoading
                                                                  ? "block"
                                                                  : "none"
                                                              }`,
                                                              attrs: {
                                                                viewBox:
                                                                  "0 0 24 24",
                                                                fill: "none",
                                                                xmlns:
                                                                  "http://www.w3.org/2000/svg",
                                                                stroke: "#000",
                                                              },
                                                            },
                                                            [
                                                              _c("path", {
                                                                attrs: {
                                                                  "fill-rule":
                                                                    "evenodd",
                                                                  "clip-rule":
                                                                    "evenodd",
                                                                  d: "M15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-.82 4.74a6 6 0 1 1 1.06-1.06l4.79 4.79-1.06 1.06-4.79-4.79Z",
                                                                  fill: "#080341",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _c("div", {
                                                            staticClass:
                                                              "geneLoader",
                                                            style: `display:${
                                                              _vm.geneLoading
                                                                ? "block"
                                                                : "none"
                                                            }`,
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm.genesNotFound.length > 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            "flex-direction":
                                                              "column",
                                                            gap: "1px",
                                                            flex: "0 0 auto",
                                                            "max-height":
                                                              "100%",
                                                            "overflow-y":
                                                              "auto",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.genesNotFound,
                                                          function (gene) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  display:
                                                                    "flex",
                                                                  gap: "5px",
                                                                  width: "100%",
                                                                  background:
                                                                    "#ff4500",
                                                                  color:
                                                                    "white",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        display:
                                                                          "flex",
                                                                        flex: "1",
                                                                        "align-items":
                                                                          "center",
                                                                        padding:
                                                                          "0 5px",
                                                                        "font-size":
                                                                          "12px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        gene
                                                                      ) +
                                                                        " not found."
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "28px",
                                                                        height:
                                                                          "28px",
                                                                        display:
                                                                          "flex",
                                                                        "align-items":
                                                                          "center",
                                                                        "justify-content":
                                                                          "center",
                                                                        "font-size":
                                                                          "18px",
                                                                        "line-height":
                                                                          "18px",
                                                                        cursor:
                                                                          "pointer",
                                                                      },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.clearGeneNotFound(
                                                                            gene
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [_vm._v("×")]
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "research-single-cell-selector",
                                                    {
                                                      staticStyle: {
                                                        "margin-top": "4px",
                                                        "flex-grow": "1",
                                                        "overflow-x": "hidden",
                                                        "overflow-y": "auto",
                                                      },
                                                      attrs: {
                                                        data: _vm.sortedGeneNames,
                                                        layout: "list",
                                                        listSelection:
                                                          "exclusive",
                                                        colors: null,
                                                        selectedField:
                                                          _vm.geneExpressionVars
                                                            .selectedGene,
                                                      },
                                                      on: {
                                                        "on-update": function (
                                                          $event
                                                        ) {
                                                          return _vm.geneClick(
                                                            $event
                                                              .coloredLabels[0]
                                                          )
                                                        },
                                                      },
                                                    }
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    gap: "5px",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-direction": "column",
                                        padding: "20px",
                                        background: "white",
                                        gap: "5px",
                                      },
                                    },
                                    [
                                      _vm._m(1),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            gap: "10px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-weight": "bold",
                                              },
                                            },
                                            [_vm._v("Trait")]
                                          ),
                                          _c(
                                            "select",
                                            {
                                              staticStyle: {
                                                width: "100%",
                                                "max-width": "500px",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.selectSegmentBy(
                                                    _vm.cellCompositionVars
                                                      .displayByLabel,
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                { attrs: { value: "" } },
                                                [_vm._v("--Select--")]
                                              ),
                                              _vm._l(
                                                _vm.traitFields.show,
                                                function (value, key) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      domProps: { value: key },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.displayLabel(
                                                              key
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              Object.keys(_vm.traitFields.hide)
                                                .length > 0
                                                ? _c(
                                                    "optgroup",
                                                    {
                                                      attrs: {
                                                        label: "Unused",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.traitFields.hide,
                                                      function (value, key) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              disabled: "",
                                                            },
                                                            domProps: {
                                                              value: key,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.displayLabel(
                                                                    key
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        gap: "20px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            flex: "1",
                                            "max-width": "50%",
                                            gap: "20px",
                                            padding: "20px",
                                            background: "white",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content":
                                                  "space-between",
                                                gap: "10px",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-size": "16px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "bold",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.isATACseq
                                                            ? "Nuclei"
                                                            : "Cell"
                                                        ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.isNormalized
                                                              ? "Proportion"
                                                              : "Count"
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm.displayFields &&
                                                  _vm.cellCompositionVars
                                                    .segmentByLabel &&
                                                  _vm.displayFields[
                                                    _vm.cellCompositionVars
                                                      .segmentByLabel
                                                  ].dataType === "cat"
                                                    ? [
                                                        _vm._v(" by "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-style":
                                                                "italic",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayLabel(
                                                                  _vm
                                                                    .cellCompositionVars
                                                                    .displayByLabel
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" per "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-style":
                                                                "italic",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayLabel(
                                                                  _vm
                                                                    .cellCompositionVars
                                                                    .segmentByLabel
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : _vm.cellCompositionVars
                                                        .segmentByLabel
                                                    ? [
                                                        _vm._v(" by "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-style":
                                                                "italic",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayLabel(
                                                                  _vm
                                                                    .cellCompositionVars
                                                                    .segmentByLabel
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" per "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-style":
                                                                "italic",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayLabel(
                                                                  _vm
                                                                    .cellCompositionVars
                                                                    .displayByLabel
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : [
                                                        _vm._v(" by "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-style":
                                                                "italic",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayLabel(
                                                                  _vm
                                                                    .cellCompositionVars
                                                                    .displayByLabel
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                  _vm.displayFields &&
                                                  _vm.cellCompositionVars
                                                    .segmentByLabel &&
                                                  _vm.displayFields[
                                                    _vm.cellCompositionVars
                                                      .segmentByLabel
                                                  ].dataType === "cont"
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "12px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Each point represents the average " +
                                                                _vm._s(
                                                                  _vm.isATACseq
                                                                    ? "nuclei"
                                                                    : "cell"
                                                                ) +
                                                                " " +
                                                                _vm._s(
                                                                  _vm.isNormalized
                                                                    ? "proportion"
                                                                    : "distribution"
                                                                ) +
                                                                " per " +
                                                                _vm._s(
                                                                  this
                                                                    .aggregateType
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                              _c("download-chart", {
                                                staticClass: "download",
                                                staticStyle: {
                                                  width: "125px",
                                                  "align-self": "flex-start",
                                                },
                                                style: `${
                                                  _vm.contCountResults
                                                    ? "pointer-events:none; opacity:0.5"
                                                    : ""
                                                }`,
                                                attrs: {
                                                  chartId:
                                                    "sc_stacked_bar_plot",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          !_vm.cellCompositionVars
                                            .segmentByLabel ||
                                          (_vm.displayFields &&
                                            _vm.displayFields[
                                              _vm.cellCompositionVars
                                                .segmentByLabel
                                            ].dataType === "cat")
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "flex-direction": "column",
                                                    gap: "5px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "research-stacked-bar-plot",
                                                    {
                                                      attrs: {
                                                        data: _vm
                                                          .cellCompositionVars
                                                          .segmentByCounts2,
                                                        primaryKey: _vm
                                                          .cellCompositionVars
                                                          .segmentByLabel
                                                          ? _vm
                                                              .cellCompositionVars
                                                              .segmentByLabel
                                                          : _vm
                                                              .cellCompositionVars
                                                              .displayByLabel,
                                                        subsetKey: _vm
                                                          .cellCompositionVars
                                                          .segmentByLabel
                                                          ? _vm
                                                              .cellCompositionVars
                                                              .displayByLabel
                                                          : _vm
                                                              .cellCompositionVars
                                                              .segmentByLabel,
                                                        xAxisLabel: _vm
                                                          .cellCompositionVars
                                                          .segmentByLabel
                                                          ? _vm.displayLabel(
                                                              _vm
                                                                .cellCompositionVars
                                                                .segmentByLabel
                                                            )
                                                          : _vm.displayLabel(
                                                              _vm
                                                                .cellCompositionVars
                                                                .displayByLabel
                                                            ),
                                                        yAxisLabel: `${
                                                          _vm.isNormalized
                                                            ? "Percent of " +
                                                              (_vm.isATACseq
                                                                ? "Nuclei"
                                                                : "Cells")
                                                            : "Number of " +
                                                              (_vm.isATACseq
                                                                ? "Nuclei"
                                                                : "Cells")
                                                        }`,
                                                        highlightKey:
                                                          _vm
                                                            .cellCompositionVars
                                                            .highlightLabel,
                                                        normalize:
                                                          _vm.isNormalized,
                                                        stack: _vm
                                                          .cellCompositionVars
                                                          .segmentByLabel
                                                          ? true
                                                          : false,
                                                      },
                                                    }
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "12px",
                                                        opacity: "0.5",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm
                                                            .cellCompositionVars
                                                            .segmentByLabel
                                                            ? _vm.displayLabel(
                                                                _vm
                                                                  .cellCompositionVars
                                                                  .displayByLabel
                                                              )
                                                            : _vm.displayLabel(
                                                                _vm
                                                                  .cellCompositionVars
                                                                  .segmentByLabel
                                                              )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "research-single-cell-selector",
                                                    {
                                                      attrs: {
                                                        data: _vm.fields[
                                                          "metadata_labels"
                                                        ],
                                                        layout: "list",
                                                        listDirection:
                                                          "horizontal",
                                                        listAlignment: "start",
                                                        colors: _vm.labelColors,
                                                        selectedField: _vm
                                                          .cellCompositionVars
                                                          .segmentByLabel
                                                          ? _vm
                                                              .cellCompositionVars
                                                              .displayByLabel
                                                          : _vm
                                                              .cellCompositionVars
                                                              .segmentByLabel,
                                                      },
                                                      on: {
                                                        "on-update": function (
                                                          $event
                                                        ) {
                                                          return _vm.handleSelectorUpdate(
                                                            $event
                                                          )
                                                        },
                                                        "on-hover": function (
                                                          $event
                                                        ) {
                                                          return _vm.handleSelectorHover(
                                                            $event
                                                          )
                                                        },
                                                      },
                                                    }
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.contCountResults
                                            ? _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "12px",
                                                      opacity: "0.5",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.displayLabel(
                                                          _vm
                                                            .cellCompositionVars
                                                            .displayByLabel
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      "flex-wrap": "wrap",
                                                      gap: "10px",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.contCountResults,
                                                    function (item) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            "min-width":
                                                              "250px",
                                                            flex: "1",
                                                          },
                                                        },
                                                        [
                                                          _c("div", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.groupKey
                                                              )
                                                            ),
                                                          ]),
                                                          _c(
                                                            "research-scatter-plot",
                                                            {
                                                              attrs: {
                                                                data: item.data,
                                                                width: 300,
                                                                height: 150,
                                                                xKey: _vm
                                                                  .cellCompositionVars
                                                                  .segmentByLabel,
                                                                yKey: "cell_proportion",
                                                                xLabel:
                                                                  _vm.displayLabel(
                                                                    _vm
                                                                      .cellCompositionVars
                                                                      .segmentByLabel
                                                                  ),
                                                                yLabel:
                                                                  "Cell Proportion",
                                                                yDomain: [0, 1],
                                                                renderAs: "svg",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm.geneExpressionVars.expressionStats
                                        .length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                                flex: "1",
                                                "max-width": "50%",
                                                gap: "20px",
                                                padding: "20px",
                                                background: "white",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content":
                                                      "space-between",
                                                    gap: "10px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "16px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-weight":
                                                              "bold",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .geneExpressionVars
                                                                .selectedGene
                                                            ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.isATACseq
                                                                  ? "Chromatin Accessibility"
                                                                  : "Expression"
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm.displayFields &&
                                                      _vm.cellCompositionVars
                                                        .segmentByLabel &&
                                                      _vm.displayFields[
                                                        _vm.cellCompositionVars
                                                          .segmentByLabel
                                                      ].dataType === "cat"
                                                        ? [
                                                            _vm._v(" by "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "font-style":
                                                                    "italic",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.displayLabel(
                                                                      _vm
                                                                        .cellCompositionVars
                                                                        .displayByLabel
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" per "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "font-style":
                                                                    "italic",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.displayLabel(
                                                                      _vm
                                                                        .cellCompositionVars
                                                                        .segmentByLabel
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        : _vm
                                                            .cellCompositionVars
                                                            .segmentByLabel
                                                        ? [
                                                            _vm._v(" by "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "font-style":
                                                                    "italic",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.displayLabel(
                                                                      _vm
                                                                        .cellCompositionVars
                                                                        .segmentByLabel
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" per "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "font-style":
                                                                    "italic",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.displayLabel(
                                                                      _vm
                                                                        .cellCompositionVars
                                                                        .displayByLabel
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        : [
                                                            _vm._v(" by "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "font-style":
                                                                    "italic",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.displayLabel(
                                                                      _vm
                                                                        .cellCompositionVars
                                                                        .displayByLabel
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                      _vm.displayFields &&
                                                      _vm.cellCompositionVars
                                                        .segmentByLabel &&
                                                      _vm.displayFields[
                                                        _vm.cellCompositionVars
                                                          .segmentByLabel
                                                      ].dataType === "cont"
                                                        ? [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Each point represents the average " +
                                                                    _vm._s(
                                                                      _vm.isATACseq
                                                                        ? "chromatin accessibility"
                                                                        : "gene expression"
                                                                    ) +
                                                                    " per " +
                                                                    _vm._s(
                                                                      this
                                                                        .aggregateType
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        : _vm._e(),
                                                      !_vm.coordinates
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                display: "flex",
                                                                "flex-direction":
                                                                  "column",
                                                                gap: "5px",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    display:
                                                                      "flex",
                                                                    gap: "5px",
                                                                  },
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm.geneToSearch,
                                                                          expression:
                                                                            "geneToSearch",
                                                                        },
                                                                      ],
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "100%",
                                                                        position:
                                                                          "relative",
                                                                      },
                                                                    attrs: {
                                                                      type: "text",
                                                                      placeholder:
                                                                        "Gene name",
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        _vm.geneToSearch,
                                                                    },
                                                                    on: {
                                                                      keyup:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            !$event.type.indexOf(
                                                                              "key"
                                                                            ) &&
                                                                            _vm._k(
                                                                              $event.keyCode,
                                                                              "enter",
                                                                              13,
                                                                              $event.key,
                                                                              "Enter"
                                                                            )
                                                                          )
                                                                            return null
                                                                          return _vm.searchGene(
                                                                            _vm.geneToSearch
                                                                          )
                                                                        },
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          )
                                                                            return
                                                                          _vm.geneToSearch =
                                                                            $event.target.value
                                                                        },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "button",
                                                                    {
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.searchGene(
                                                                              _vm.geneToSearch
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "svg",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              width:
                                                                                "20px",
                                                                            },
                                                                          style: `display:${
                                                                            !_vm.geneLoading
                                                                              ? "block"
                                                                              : "none"
                                                                          }`,
                                                                          attrs:
                                                                            {
                                                                              viewBox:
                                                                                "0 0 24 24",
                                                                              fill: "none",
                                                                              xmlns:
                                                                                "http://www.w3.org/2000/svg",
                                                                              stroke:
                                                                                "#000",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "path",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  "fill-rule":
                                                                                    "evenodd",
                                                                                  "clip-rule":
                                                                                    "evenodd",
                                                                                  d: "M15 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-.82 4.74a6 6 0 1 1 1.06-1.06l4.79 4.79-1.06 1.06-4.79-4.79Z",
                                                                                  fill: "#080341",
                                                                                },
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "geneLoader",
                                                                          style: `display:${
                                                                            _vm.geneLoading
                                                                              ? "block"
                                                                              : "none"
                                                                          }`,
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm.genesNotFound
                                                                .length > 0
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          display:
                                                                            "flex",
                                                                          "flex-direction":
                                                                            "column",
                                                                          gap: "1px",
                                                                          flex: "0 0 auto",
                                                                          "max-height":
                                                                            "100%",
                                                                          "overflow-y":
                                                                            "auto",
                                                                        },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.genesNotFound,
                                                                      function (
                                                                        gene
                                                                      ) {
                                                                        return _c(
                                                                          "div",
                                                                          {
                                                                            staticStyle:
                                                                              {
                                                                                display:
                                                                                  "flex",
                                                                                gap: "5px",
                                                                                width:
                                                                                  "100%",
                                                                                background:
                                                                                  "#ff4500",
                                                                                color:
                                                                                  "white",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    display:
                                                                                      "flex",
                                                                                    flex: "1",
                                                                                    "align-items":
                                                                                      "center",
                                                                                    padding:
                                                                                      "0 5px",
                                                                                    "font-size":
                                                                                      "12px",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    gene
                                                                                  ) +
                                                                                    " not found."
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    width:
                                                                                      "28px",
                                                                                    height:
                                                                                      "28px",
                                                                                    display:
                                                                                      "flex",
                                                                                    "align-items":
                                                                                      "center",
                                                                                    "justify-content":
                                                                                      "center",
                                                                                    "font-size":
                                                                                      "18px",
                                                                                    "line-height":
                                                                                      "18px",
                                                                                    cursor:
                                                                                      "pointer",
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.clearGeneNotFound(
                                                                                        gene
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "×"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  ),
                                                  _c("download-chart", {
                                                    staticClass: "download",
                                                    staticStyle: {
                                                      width: "125px",
                                                      "align-self":
                                                        "flex-start",
                                                    },
                                                    style: `${
                                                      _vm.contExprResults ||
                                                      _vm.cellCompositionVars
                                                        .segmentByLabel !== ""
                                                        ? "pointer-events:none; opacity:0.5"
                                                        : ""
                                                    }`,
                                                    attrs: {
                                                      chartId: "sc_violin_plot",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              !_vm.contExprResults
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "flex-direction":
                                                          "column",
                                                        gap: "5px",
                                                      },
                                                    },
                                                    [
                                                      _vm.cellCompositionVars
                                                        .segmentByLabel === ""
                                                        ? [
                                                            _c(
                                                              "research-violin-plot",
                                                              {
                                                                attrs: {
                                                                  data: _vm
                                                                    .geneExpressionVars
                                                                    .expressionStats,
                                                                  primaryKey:
                                                                    _vm
                                                                      .geneExpressionVars
                                                                      .selectedLabel,
                                                                  subsetKey:
                                                                    _vm
                                                                      .cellCompositionVars
                                                                      .segmentByLabel,
                                                                  highlightKey:
                                                                    _vm
                                                                      .cellCompositionVars
                                                                      .highlightLabel,
                                                                  height: 300,
                                                                  xAxisLabel:
                                                                    "Log-Normalized Expression",
                                                                  xAxisLabel:
                                                                    _vm.isATACseq
                                                                      ? "Gene Activity Score"
                                                                      : "Log-Normalized Expression",
                                                                  yAxisLabel:
                                                                    _vm.displayLabel(
                                                                      _vm
                                                                        .geneExpressionVars
                                                                        .selectedLabel
                                                                    ),
                                                                },
                                                              }
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px",
                                                                  opacity:
                                                                    "0.5",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.displayLabel(
                                                                      _vm
                                                                        .cellCompositionVars
                                                                        .segmentByLabel
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "research-single-cell-selector",
                                                              {
                                                                attrs: {
                                                                  data: _vm
                                                                    .fields[
                                                                    "metadata_labels"
                                                                  ],
                                                                  layout:
                                                                    "list",
                                                                  listDirection:
                                                                    "horizontal",
                                                                  listAlignment:
                                                                    "start",
                                                                  colors:
                                                                    _vm.labelColors,
                                                                  selectedField:
                                                                    _vm
                                                                      .cellCompositionVars
                                                                      .segmentByLabel,
                                                                },
                                                                on: {
                                                                  "on-update":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleSelectorUpdate(
                                                                        $event
                                                                      )
                                                                    },
                                                                  "on-hover":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleSelectorHover(
                                                                        $event
                                                                      )
                                                                    },
                                                                },
                                                              }
                                                            ),
                                                          ]
                                                        : [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px",
                                                                  opacity:
                                                                    "0.5",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.displayLabel(
                                                                      _vm
                                                                        .cellCompositionVars
                                                                        .segmentByLabel
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._l(
                                                              _vm.fields[
                                                                "metadata_labels"
                                                              ][
                                                                _vm
                                                                  .cellCompositionVars
                                                                  .segmentByLabel
                                                              ],
                                                              function (value) {
                                                                return _c(
                                                                  "div",
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            display:
                                                                              "flex",
                                                                            gap: "3px",
                                                                            "align-items":
                                                                              "baseline",
                                                                          },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticStyle:
                                                                              {
                                                                                "font-weight":
                                                                                  "bold",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                value
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "research-violin-plot",
                                                                      {
                                                                        attrs: {
                                                                          data: _vm.getStatsByPropValue(
                                                                            _vm
                                                                              .geneExpressionVars
                                                                              .expressionStats,
                                                                            _vm
                                                                              .cellCompositionVars
                                                                              .segmentByLabel,
                                                                            value
                                                                          ),
                                                                          primaryKey:
                                                                            _vm
                                                                              .geneExpressionVars
                                                                              .selectedLabel,
                                                                          highlightKey:
                                                                            _vm
                                                                              .cellCompositionVars
                                                                              .highlightLabel,
                                                                          height: 300,
                                                                          xAxisLabel:
                                                                            "Log-Normalized Expression",
                                                                          yAxisLabel:
                                                                            _vm.displayLabel(
                                                                              _vm
                                                                                .geneExpressionVars
                                                                                .selectedLabel
                                                                            ),
                                                                          range:
                                                                            [
                                                                              _vm.minExpressionValue(
                                                                                _vm
                                                                                  .geneExpressionVars
                                                                                  .selectedGene
                                                                              ),
                                                                              _vm.maxExpressionValue(
                                                                                _vm
                                                                                  .geneExpressionVars
                                                                                  .selectedGene
                                                                              ),
                                                                            ],
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                          ],
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm.contExprResults
                                                ? _c("div", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "12px",
                                                          opacity: "0.5",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.displayLabel(
                                                              _vm
                                                                .cellCompositionVars
                                                                .displayByLabel
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          display: "flex",
                                                          "flex-wrap": "wrap",
                                                          gap: "10px",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.contExprResults,
                                                        function (item) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "min-width":
                                                                  "250px",
                                                                flex: "1",
                                                              },
                                                            },
                                                            [
                                                              _c("div", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.groupKey
                                                                  )
                                                                ),
                                                              ]),
                                                              _c(
                                                                "research-scatter-plot",
                                                                {
                                                                  attrs: {
                                                                    data: item.data,
                                                                    width: 300,
                                                                    height: 150,
                                                                    xKey: _vm
                                                                      .cellCompositionVars
                                                                      .segmentByLabel,
                                                                    yKey: _vm
                                                                      .geneExpressionVars
                                                                      .selectedGene,
                                                                    xLabel:
                                                                      _vm.displayLabel(
                                                                        _vm
                                                                          .cellCompositionVars
                                                                          .segmentByLabel
                                                                      ),
                                                                    yLabel:
                                                                      "Log-Norm. Expression",
                                                                    yDomain: [
                                                                      0,
                                                                      Math.ceil(
                                                                        _vm.maxExpressionValue(
                                                                          _vm
                                                                            .geneExpressionVars
                                                                            .selectedGene
                                                                        )
                                                                      ),
                                                                    ],
                                                                    renderAs:
                                                                      "svg",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: { display: "flex", gap: "25px" },
                                },
                                [
                                  _vm.markers &&
                                  (_vm.markerGenes ||
                                    _vm.expressionStatsAll.length > 0)
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            gap: "20px",
                                            background: "white",
                                            padding: "20px",
                                            width: "100%",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-direction": "column",
                                                gap: "20px",
                                                "min-width": "50%",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content":
                                                      "space-between",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "flex-direction":
                                                          "column",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "strong",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "16px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.dotPlotCellType !=
                                                                ""
                                                                ? `Marker Genes for ${_vm.dotPlotCellType}`
                                                                : "Top Marker Genes by Cell Type"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "12px",
                                                            opacity: "0.5",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Ranked by " +
                                                              _vm._s(
                                                                _vm.markersHaveZscores
                                                                  ? "z-score"
                                                                  : "mean expression"
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("download-chart", {
                                                    staticClass: "download",
                                                    staticStyle: {
                                                      width: "125px",
                                                      "align-self":
                                                        "flex-start",
                                                    },
                                                    attrs: {
                                                      chartId: "sc_dot_plot",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content":
                                                      "space-between",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "flex-direction":
                                                          "column",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            display: "flex",
                                                            gap: "10px",
                                                            "align-items":
                                                              "baseline",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "bold",
                                                                margin:
                                                                  "0 0 5px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Cell Type"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.dotPlotCellType,
                                                                  expression:
                                                                    "dotPlotCellType",
                                                                },
                                                              ],
                                                              on: {
                                                                change: [
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal =
                                                                      Array.prototype.filter
                                                                        .call(
                                                                          $event
                                                                            .target
                                                                            .options,
                                                                          function (
                                                                            o
                                                                          ) {
                                                                            return o.selected
                                                                          }
                                                                        )
                                                                        .map(
                                                                          function (
                                                                            o
                                                                          ) {
                                                                            var val =
                                                                              "_value" in
                                                                              o
                                                                                ? o._value
                                                                                : o.value
                                                                            return val
                                                                          }
                                                                        )
                                                                    _vm.dotPlotCellType =
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                  },
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.showMarkersByCellType(
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                                ],
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "",
                                                                  },
                                                                },
                                                                [_vm._v("All")]
                                                              ),
                                                              _vm._l(
                                                                _vm.markerCellTypes,
                                                                function (
                                                                  label
                                                                ) {
                                                                  return _c(
                                                                    "option",
                                                                    {
                                                                      domProps:
                                                                        {
                                                                          value:
                                                                            label,
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            label
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                            ],
                                                            2
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "13px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Select a cell type to view its full marker profile."
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "legends",
                                                      staticStyle: {
                                                        display: "flex",
                                                        gap: "5px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "legend",
                                                          staticStyle: {
                                                            display: "flex",
                                                            "flex-direction":
                                                              "column",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Mean Expression"
                                                              ),
                                                            ]
                                                          ),
                                                          _c("div", {
                                                            staticClass:
                                                              "gradient",
                                                            style: `background: linear-gradient(to right, ${_vm.colorScalePlasmaColorsArray});`,
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "marks",
                                                              staticStyle: {
                                                                display: "flex",
                                                              },
                                                            },
                                                            [
                                                              _c("div", [
                                                                _vm._v("0.0"),
                                                              ]),
                                                              _c("div", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.markerGenesMaxMean
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._m(2),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c("research-dot-plot", {
                                                staticStyle: {
                                                  display: "flex",
                                                  "align-self": "center",
                                                },
                                                attrs: {
                                                  data:
                                                    _vm.markerGenes ||
                                                    _vm.expressionStatsAll,
                                                  "data-blah": "pct_nz_group",
                                                  yKey: "cell_type",
                                                  xKey: "gene",
                                                  yLabel: "Cell Type",
                                                  xLabel: "Gene",
                                                  fillKey: "mean_expression",
                                                  sizeKey:
                                                    _vm.markerGenesSizeKey,
                                                  fitToSize: true,
                                                  cellWidth: 30,
                                                  highlightKey: "",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm.markerGenesTable
                                            ? _c("b-table", {
                                                staticStyle: {
                                                  "font-size": "12px",
                                                },
                                                attrs: {
                                                  items: _vm.markerGenesTable,
                                                  fields:
                                                    _vm.markerTableColumns,
                                                  striped: "",
                                                  hover: "",
                                                  small: "",
                                                  responsive: "sm",
                                                  "head-variant": "light",
                                                  "sticky-header": "300px",
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.layout === 1
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        width: "100%",
                        "align-self": "center",
                      },
                    },
                    [
                      _c("research-single-cell-info", {
                        attrs: { data: _vm.metadata },
                      }),
                      _vm.dataReady
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                gap: "40px",
                                flex: "1",
                              },
                            },
                            [
                              _c("research-single-cell-selector", {
                                staticStyle: { "max-width": "200px" },
                                attrs: {
                                  data: _vm.fields["metadata_labels"],
                                  layout: "dropdown-list",
                                  showSelect: false,
                                  colors: _vm.labelColors,
                                  selectedField:
                                    _vm.cellCompositionVars.colorByField,
                                },
                                on: {
                                  "on-update": function ($event) {
                                    return _vm.handleSelectorUpdate($event)
                                  },
                                  "on-hover": function ($event) {
                                    return _vm.handleSelectorHover($event)
                                  },
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    gap: "20p",
                                    width: "400px",
                                  },
                                },
                                [
                                  _vm.coordinates
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            flex: "1",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content":
                                                  "space-between",
                                                "align-items": "baseline",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-size": "16px",
                                                    margin: "0 0 5px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "bold",
                                                      },
                                                    },
                                                    [_vm._v("UMAP")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-style": "italic",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.geneExpressionVars
                                                            .selectedGene
                                                            ? `${_vm.geneExpressionVars.selectedGene}`
                                                            : ""
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.totalCells.toLocaleString()
                                                  ) +
                                                  " cells "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                position: "relative",
                                              },
                                            },
                                            [
                                              _c("research-umap-plot-gl", {
                                                attrs: {
                                                  group: _vm.datasetId,
                                                  points: _vm.coordinates,
                                                  labels: _vm.fields,
                                                  colors: _vm.labelColors,
                                                  expression:
                                                    _vm.expressionData[
                                                      _vm.geneExpressionVars
                                                        .selectedGene
                                                    ],
                                                  cellTypeField:
                                                    _vm.cellTypeField,
                                                  hoverFields: [],
                                                  highlightLabel:
                                                    _vm.cellCompositionVars
                                                      .highlightLabel,
                                                  highlightLabels:
                                                    _vm.cellCompositionVars
                                                      .highlightLabels,
                                                  width: 400,
                                                  height: 400,
                                                },
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "legend",
                                                  staticStyle: {
                                                    display: "flex",
                                                    "flex-direction": "column",
                                                    position: "absolute",
                                                    top: "4px",
                                                    left: "5px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "label" },
                                                    [_vm._v("Expression")]
                                                  ),
                                                  _c("div", {
                                                    staticClass: "gradient",
                                                    style: `background: linear-gradient(to right, ${_vm.colorScalePlasmaColorsArray}); height:5px;`,
                                                  }),
                                                  _vm._m(3),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm.geneExpressionVars.expressionStats.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-direction": "column",
                                        flex: "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            gap: "5px",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "16px",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "bold",
                                                  },
                                                },
                                                [_vm._v("Gene Expression")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-style": "italic",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.geneExpressionVars
                                                        .selectedGene
                                                        ? `${_vm.geneExpressionVars.selectedGene}`
                                                        : ""
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c("research-violin-plot", {
                                        attrs: {
                                          data: _vm.geneExpressionVars
                                            .expressionStats,
                                          primaryKey:
                                            _vm.geneExpressionVars
                                              .selectedLabel,
                                          subsetKey:
                                            _vm.geneExpressionVars.subsetLabel,
                                          highlightKey:
                                            _vm.cellCompositionVars
                                              .highlightLabel,
                                          height: 400,
                                          xAxisLabel:
                                            "Log-Normalized Expression",
                                          yAxisLabel:
                                            _vm.geneExpressionVars
                                              .selectedLabel,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", [
      _c(
        "div",
        { staticStyle: { "font-weight": "bold", "font-size": "16px" } },
        [_vm._v("Select Tissue")]
      ),
      _c("div", [_vm._v("Click on a row to select")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticStyle: { display: "flex", "flex-direction": "column" } },
      [
        _c(
          "div",
          { staticStyle: { "font-weight": "bold", "font-size": "16px" } },
          [_vm._v("Trait Exploration")]
        ),
        _c("div", [
          _vm._v(
            " Stratify cell count and gene expression plots by the chosen trait across cell types. "
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "legend",
        staticStyle: { display: "flex", "flex-direction": "column" },
      },
      [
        _c("div", { staticClass: "label" }, [_vm._v("% Cells Expressing")]),
        _c(
          "div",
          { staticClass: "circles", staticStyle: { display: "flex" } },
          [
            _c("div", { staticClass: "circleBorder" }, [
              _c("div", {
                staticClass: "circle",
                staticStyle: { height: "20%" },
              }),
            ]),
            _c("div", { staticClass: "circleBorder" }, [
              _c("div", {
                staticClass: "circle",
                staticStyle: { height: "40%" },
              }),
            ]),
            _c("div", { staticClass: "circleBorder" }, [
              _c("div", {
                staticClass: "circle",
                staticStyle: { height: "60%" },
              }),
            ]),
            _c("div", { staticClass: "circleBorder" }, [
              _c("div", {
                staticClass: "circle",
                staticStyle: { height: "80%" },
              }),
            ]),
            _c("div", { staticClass: "circleBorder" }, [
              _c("div", {
                staticClass: "circle",
                staticStyle: { height: "100%" },
              }),
            ]),
          ]
        ),
        _c("div", { staticClass: "marks", staticStyle: { display: "flex" } }, [
          _c("div", [_vm._v("0")]),
          _c("div", [_vm._v("100")]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "marks", staticStyle: { display: "flex" } },
      [_c("div", [_vm._v("0.0")]), _c("div", [_vm._v("3.0")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }